<template>
  <v-container
  align-center
  fluid
  >
    <v-row justify="space-around">
      <!-- <v-col>
        <Adsense
          data-ad-client="ca-pub-0588060391204034"
          data-ad-slot="4056412151"
          :data-ad-format="auto"
          :data-full-width-responsive=true
        >
        </Adsense>
      </v-col> -->
    </v-row>
    <v-row justify="space-around">
      <v-col cols=8>
        <h1>Thank You!</h1>
        <p>
          for using Reddit.Watch.
        </p>

        <v-btn
          elevation="2"
          x-large
          color="#f78d00"
          dark
          href="https://forms.gle/2N641sLYUYDEazMC9"
        >
          <v-icon
          left
          >chat_bubble</v-icon>
          Send Feedback
        </v-btn>

      </v-col>
    </v-row>
    <!-- <v-row justify="space-around">
      <v-col>
        <Adsense
          data-ad-client="ca-pub-0588060391204034"
          data-ad-slot="6505846409"
          :data-ad-format="auto"
          :data-full-width-responsive=true
        >
        </Adsense>
      </v-col>
    </v-row> -->
  </v-container>
</template>

<script>
export default {
  data: () => ({
  }),
};
</script>
